import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Alert from '@mui/material/Alert';
import Divider from '@mui/material/Divider';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import CustomAlert from '../shared/CustomAlert';
import PageLayout from '../shared/PageLayout/PageLayout';
import PendingSubAccountTable from './shared/PendingSubAccountTable';
import SubAccountTable from './shared/SubAccountTable';

const ManageSubAccounts = () => {
	const [alertText, setAlertText] = useState();
	const location = useLocation();
	const { email } = location.state || {};

	const consumeSessionStorage = () => {
		sessionStorage.removeItem('isTerm');
		sessionStorage.removeItem('isCreate');
		sessionStorage.removeItem('isConfirmed');
	};

	useEffect(() => {
		// If you're unable to see the banner in local, it's because the app is in strict mode which causes the cleanup function to also run on the initial render
		// This is only an issue in development and does not happen in a production build. If you want to see this run in local you can just comment out the <React.StrictMode>
		// component in the index.js file

		let text = {};

		if (sessionStorage.getItem('isTerm')) {
			text = {
				title: 'Sub Account Successfully Terminated',
				description: `${email} has been terminated.`,
			};
		}

		if (sessionStorage.getItem('isCreate')) {
			text = {
				title: 'Sub Account Creation Invite Sent',
				description: `An email has been sent to ${email} for them to create their account. The link will expire after 72 hours.`,
			};
		}

		if (sessionStorage.getItem('isConfirmed')) {
			text = {
				title: 'Sub Account Updated',
				description: `Sub account ${email} has been updated`,
			};
		}

		// Must consume storage on render as redirect to legacy doesn't trigger the useEffect cleanup function
		setAlertText(text);
		consumeSessionStorage();
	}, []);

	return (
		<PageLayout pageTitle='Manage Sub Accounts'>
			<Paper elevation={0} sx={{ py: 2, px: { md: 4, lg: 4 } }}>
				<Typography variant='h5' component='h5' my={1}>
					Sub Accounts
				</Typography>
				<Divider />
				<Typography variant='body1' my={2}>
					Add new and/or manage all of your sub accounts.
				</Typography>
				{alertText?.title && (
					<CustomAlert
						onClose={() => setAlertText('', '')}
						headerText={alertText.title}
						bodyText={alertText.description}
					/>
				)}
				<Alert severity='info' sx={{ mb: 3 }}>
					<Typography fontWeight={700}>
						What is a Sub Account?
					</Typography>
					<Typography variant='body1'>
						Sub Accounts provide a user access to an individual
						provider account and multiple clinic locations under the
						same provider. This access is typically intended for
						practitioners and other office staff. Depending on the
						level of access, the designated users can submit eMNRs,
						eClaims, or access Remittance Advice.
					</Typography>
				</Alert>
				<SubAccountTable />
			</Paper>
			<Paper elevation={0} sx={{ mt: 4, py: 2, px: { md: 4, lg: 4 } }}>
				<Typography variant='h5' component='h5' my={1}>
					Pending Sub Accounts
				</Typography>
				<Divider sx={{ mb: 4 }} />
				<PendingSubAccountTable />
			</Paper>
		</PageLayout>
	);
};
export default ManageSubAccounts;
